export default "__VITE_ASSET__EaaIPw8b__"